import { uploadChunk } from "@/api";

export const sendFileChunks = async (file: File, fileId: string, sessionId: string, uploadedSize: number) => {
    const chunkSize = 100 * 1024 * 1024;
    let cursor = uploadedSize;

    const remainingBytes = file.size - cursor;
    const remainingChunks = Math.ceil(remainingBytes / chunkSize);

    console.log(`Resuming upload from byte ${cursor}, ${remainingChunks} chunks remaining`);

    while (cursor < file.size) {
        const chunkEnd = Math.min(cursor + chunkSize, file.size);
        const chunk = file.slice(cursor, chunkEnd);

        console.log(`Uploading chunk from ${cursor}-${chunkEnd} (size: ${chunk.size})`);
        const { response } = await uploadChunk(chunk, fileId, sessionId, cursor);
        if (response.status === 404) {
            console.log("Session expired, stopping upload");
            return;
        }
        if (!response.ok) {
            alert(`Failed to upload chunk ${cursor}-${chunkEnd}: ${response.statusText}`);
            console.error(`Failed to upload chunk ${cursor}-${chunkEnd}: ${response.statusText}`);
            return;
        }
        cursor = chunkEnd;
    }

    console.log("File upload completed");
};
